




































import { WhtAmountType } from "@/enums/enums";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class DropdownTaxWithheld extends Vue {
  @Prop({}) readonly index!: number;
  @Prop({}) readonly transactionItem!: any;
  @Prop({}) readonly transactionCreate!: any;

  private listTaxWithheld = [
    { name: "กำหนดเอง", value: WhtAmountType.Custom },
    { name: "ยังไม่ระบุ", value: WhtAmountType.NotSpecify },
    { name: "ไม่มี", value: WhtAmountType.None },
    { name: "0.75%", value: WhtAmountType.ZeroPointSevenFive },
    { name: "1%", value: WhtAmountType.OnePercent },
    { name: "1.5%", value: WhtAmountType.OnePointFivePercent },
    { name: "2%", value: WhtAmountType.TwoPercent },
    { name: "3%", value: WhtAmountType.ThreePercent },
    { name: "5%", value: WhtAmountType.FivePercent },
    { name: "10%", value: WhtAmountType.TenPercent },
    { name: "15%", value: WhtAmountType.FifteenPercent },
  ];
  private selectTaxWithheld: any = "";
  private chooseThiswithheld: any = "";
  private withheldValue: any = "0.00";
  private transactionItemWht: any = "";

  @Watch("transactionItem.itemWht.whtAmountType", { immediate: true, deep: true })
  itemWhtChanged() {
    this.transactionItemWht = this.transactionItem.itemWht;
    this.withheldValue = this.transactionItem.itemWht.value ? this.transactionItem.itemWht.value : "0.00";
    this.selectTaxWithheld = { value: this.transactionItem.itemWht.whtAmountType };
    this.SelectWhtAmount(this.listTaxWithheld.find((x) => x.value === this.transactionItem.itemWht.whtAmountType));
  }

  @Watch("selectTaxWithheld")
  selectTaxWithheldChanged() {
    this.SelectWhtAmount(this.selectTaxWithheld);
  }

  public SelectWhtAmount(item: any) {
    this.transactionItemWht.whtAmountType = item.value;
    if (this.transactionItemWht.whtAmountType == WhtAmountType.Custom) {
      this.transactionItemWht.value = this.withheldValue;
    } else {
      this.transactionItemWht.value = "0.00";
    }
    this.transactionItem.itemWht = this.transactionItemWht;
    this.$emit("change");
  }

  public ChooseThis(item: any) {
    this.chooseThiswithheld = item;
  }
}
